// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Popular } from '../Popular'
import './styles.scss'

export class Section3 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section three'>
       <div className="wrapper">
        <h2>Das sind die beliebtesten Rassen</h2>

        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                <p>
                  Schweizerinnen und Schweizer bevorzugen kleine Hunde wie zum Beispiel Malteser, also solche, die weniger als 45 Zentimeter gross und leichter als 15 Kilogramm sind. Danach folgen grosse Hunde wie Labradore und mittlere wie Border Collie. Weitaus weniger beliebt sind sehr grosse Hunde wie Deutsche Doggen.
                </p>
              </div>
              <div className="chart">
                <Popular />
              </div>
              <div className='txt'>
                <p>
                  Und so überrascht es nicht, dass ein kleiner Hund die Rangliste der beliebtesten Rassen (ohne Mischlinge und Kreuzungen) anführt: Der Chihuahua ist sogar die kleinste Hunderasse der Welt und kommt in der Schweiz fast 29'000-mal vor. Knapp dahinter folgt mit etwas mehr als 25'000 Exemplaren der Labrador. Als Dritter aufs Podest schafft es der Yorkshire Terrier, den es in der Schweiz 18'000-mal gibt.
                </p>
                <p>
                  Chihuahuas sind schon seit längerem beliebt, im Vergleich zu 2016 ist ihre Zahl aber nur um 24 Prozent gestiegen. Andere Rassen haben deutlich stärker zugelegt: Die Anzahl Zwergspitze beispielsweise stieg um über 200 Prozent auf gut 13’000, diejenige der Französischen Bulldoggen verdoppelte sich fast auf 16’000 – beides sind ebenfalls kleine Rassen. Im Vergleich zu grossen Hunden sind kleine günstiger, einfacher zu transportieren und werden auch öfter von Wohnungsvermietern zugelassen.
                </p>
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/Pu86y/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  }
}
